<template>
  <!-- begin:: Header -->
  <div
    id="kt_header"
    ref="kt_header"
    class="header"
    v-bind:class="headerClasses"
  >
    <div
      class="container-fluid d-flex align-items-right justify-content-between"
    >
      <!-- begin:: Header Menu -->
      <div
        class="header-menu-wrapper header-menu-wrapper-left col p-0 align-self-center"
        ref="kt_header_menu_wrapper"
      >
        <div class="row align-items-center">
          <div class="col-auto">
            <h6
              class="mb-0 font-weight-bolder align-items-center"
              v-blur-sensitive
              v-html="currentUserPersonalInfo.cliente"
            ></h6>
            <p
              class="mb-0"
              v-if="currentUserPersonalInfo.conta"
              v-b-tooltip.html="
                isPresentationMode
                  ? 'Código da conta oculto no modo apresentação'
                  : currentUserPersonalInfo.conta_id
              "
            >
              <span v-blur-sensitive class="font-weight-bolder">
                @{{ currentUserPersonalInfo.conta }}
              </span>
            </p>
            <p class="mb-0" v-if="currentUserPersonalInfo.emailCliente">
              <span class="font-weight-bolder">Email:</span>
              <span v-blur-sensitive>
                {{ currentUserPersonalInfo.emailCliente }}
              </span>
            </p>
          </div>

          <div
            class="col-auto"
            v-if="
              (checkSuperAdmin || isAccountAdmin) && contasParaTroca.length > 1
            "
          >
            <div class="d-flex">
              <button
                @click="trocarUsuarioOuConta"
                class="btn btn-wellon-branco btn-sm"
                :disabled="telaBloqueada"
                :title="telaBloqueada ? 'Tela bloqueada' : ''"
              >
                <i class="fas fa-arrows-to-dot"></i>
                Central de Contas
              </button>
              <button
                v-if="hasPermission('modo-apresentacao')"
                @click="togglePresentation"
                class="btn btn-wellon-branco btn-sm ml-3"
                :class="{ active: isPresentationMode }"
                :disabled="telaBloqueada"
                :title="telaBloqueada ? 'Tela bloqueada' : 'Modo Apresentação'"
              >
                <i
                  :class="
                    isPresentationMode ? 'fas fa-eye-slash' : 'fas fa-eye'
                  "
                ></i>
                {{ isPresentationMode ? "Desativar" : "Ativar" }} Apresentação
              </button>
              <button
                @click="alternarBloqueioTela"
                class="btn btn-wellon-branco btn-sm ml-3"
                :title="telaBloqueada ? 'Tela bloqueada' : 'Bloquear tela'"
              >
                <i
                  :class="
                    telaBloqueada
                      ? 'fas fa-fingerprint'
                      : 'fas fa-unlock-keyhole'
                  "
                ></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- end:: Header Menu -->

      <KTTopbar></KTTopbar>
    </div>

    <central-contas ref="centralContas"></central-contas>
  </div>
  <!-- end:: Header -->
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import KTTopbar from "@/view/layout/header/Topbar.vue";
import KTLayoutHeader from "@/assets/js/layout/base/header.js";
import Swal from "sweetalert2";
import ApiService from "@/core/services/api.service";
import CentralContas from "@/view/pages/painel/conta/central/CentralContas.vue";
import { UPDATE_PERSONAL_INFO } from "@/core/services/store/profile.module";

export default {
  name: "KTHeader",
  components: {
    KTTopbar,
    "central-contas": CentralContas
  },
  mounted() {
    // Init Desktop & Mobile Headers
    KTLayoutHeader.init("kt_header", "kt_header_mobile");
  },
  computed: {
    ...mapGetters([
      "getClasses",
      "currentUserPersonalInfo",
      "isAccountAdmin",
      "contasParaTroca",
      "checkSuperAdmin",
      "isPresentationMode",
      "hasPermission",
      "telaBloqueada"
    ]),

    /**
     * Get extra classes for header based on the options
     * @returns {null|*}
     */
    headerClasses() {
      const classes = this.getClasses("header");
      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }
      return null;
    }
  },

  methods: {
    ...mapActions(["togglePresentationMode"]),

    togglePresentation() {
      const title = `Você deseja ${
        this.isPresentationMode ? "desativar" : "ativar"
      } o modo de apresentação?`;
      const text = this.isPresentationMode
        ? "Essa ação irá revelar informações sensíveis na tela."
        : "Essa ação irá ocultar informações sensíveis na tela para apresentações.";
      Swal.fire({
        title: title,
        text: text,
        icon: "warning",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        showCancelButton: true,
        buttonsStyling: true
      }).then((result) => {
        if (result.value) {
          this.togglePresentationMode().then(() => window.location.reload());
        }
      });
    },

    // WEL-5192: bloqueio de tela pessoal. Só bloqueia (desbloqueio acontece
    // pelo formulário do LockOverlay, com o código do autenticador).
    alternarBloqueioTela() {
      if (this.telaBloqueada) {
        return;
      }

      if (this.currentUserPersonalInfo.canal_2fa !== "A") {
        Swal.fire({
          icon: "info",
          title: "Ative o aplicativo autenticador",
          text: "Para usar o bloqueio de tela, habilite o autenticador por app no seu perfil.",
          heightAuto: false
        });
        return;
      }

      ApiService.post("bloquear-tela").then(() => {
        this.$store.dispatch(UPDATE_PERSONAL_INFO, {
          ...this.currentUserPersonalInfo,
          tela_bloqueada: true
        });
      });
    },

    // Delegado ao componente CentralContas (extraído do Header): mantém o
    // mesmo gatilho de clique de sempre, só que agora abrindo o modal via ref
    // em vez de gerenciar o estado da lista aqui.
    trocarUsuarioOuConta() {
      this.$refs.centralContas.abrir();
    }
  }
};
</script>
